import React, {Component} from 'react';
import './ViewSingleCustomerSales.css';

import {FormattedMessage} from "react-intl";
import CustomerOrderItemTable from "../CustomerSalesItemTable/CustomerSalesItemTable";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import NumberFormatter from "../../../Common/NumberFormatter/NumberFormatter";
import {Link} from "react-router-dom";

class ViewSingleCustomerSales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderData: {},
            userInfo: {},
            billingAddressContact : "",
            shippingAddressContact : "",



            orderItems: [],

            orderId: this.props.match.params.id,
            billOrderInfo: {},
            shipOrderInfo: {},
            paymentDate: '',
            amount: '',
            refId: '',
            paymentMethod : '',
            createdOn: '',
            orderTotal : '',
            refundedDate : "",
            refunded : false,
            contactNumber : ""

        };
        this.getUserForOrder = this.getUserForOrder.bind(this);
        this.getOrder = this.getOrder.bind(this);
    }

    componentDidMount() {
        this.getOrder();
        this.getUserForOrder();
        // this.getPayment();
    }

    getOrder = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/orders/order/' + this.state.orderId,axiosConfig)
            .then((res) => {
                // console.log("ORDER DUO NEW --------------------------------->", res.data);
                console.log(res.data.orderSummary);
                this.setState({
                    orderData: res.data.order,
                    billOrderInfo : res.data.order.orderInfo.billingAddress,
                    shipOrderInfo : res.data.order.orderInfo.shippingAddress,
                    orderItems : res.data.order.orderItems,
                    orderTotal : res.data.orderSummary.orderTotal,
                    refId: res.data.order.payment.paymentId,
                    paymentMethod: res.data.order.payment.paymentMethod,
                    paymentDate: res.data.order.payment.createdOn,
                    createdOn: res.data.order.createdOn.substring(0, 4) +"年"+ res.data.order.createdOn.substring(5, 7) +"月"+ res.data.order.createdOn.substring(8, 10)+ "日",
                    deliveryDate: res.data.order.deliveryDate.substring(0, 4) +"年"+ res.data.order.deliveryDate.substring(5, 7) +"月"+ res.data.order.deliveryDate.substring(8, 10)+ "日",
                    refundedDate : res.data.order.refundedDate,
                    refunded : res.data.order.refunded
                });
                console.log(res.data.order);
                // console.log("ORDER DUO NEW --------------------------------->", res.data);

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };
    getUserForOrder = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/userdata/' + this.state.orderId,axiosConfig)
            .then((res) => {
                this.setState({
                    userInfo: res.data,
                    contactNumber : res.data.contactNumber.number
                });
                console.log("USER FOR ORDER DUO --------------------------------->", res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    getPayment = () => {
        axios.get(RESOURCE_BASE_URL + 'api/sales/payment/' + this.state.orderId)
            .then((res) => {
                this.setState({
                    paymentDate: res.data.createdOn,
                    amount: res.data.amount,
                    refId: res.data.paymentId
                });
                // console.log(res.data);
                // console.log("paymentDatya", res.data.createdOn)

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });

    };

    render() {
        // console.log("order data0000", this.state.orderData);
        let orderTotalFromChargeDetails = 0.0;
        let initDeliveryDate = '';
        // let initDeliveryDate="2019-04-06";
        let shippedStringDate = this.state.orderData.shippedDate;
        return (
            <div className="admin-view-single-order-content">

                <div className="admin-view-single-order-div">
                    <div className="title-1">
                        <FormattedMessage id="app.admin.order.view.single.title"
                                          defaultMessage="ORDER "
                                          description=""/>&nbsp;
                        <span>{this.state.orderData.batchNumber}</span>
                        <hr className="no-padding"/>
                    </div>

                    <div className="row">
                        <div className="row info-div-resp">
                            <div className="col-md-4">
                                <div className=" view-details-header-div">
                                    <label className="admin-admin-view-single-order-label">
                                        <FormattedMessage id="app.admin.view.single.customer.info"
                                                          defaultMessage="Customer Information "
                                                          description=""/>
                                    </label>
                                </div>

                                <div className="details-section">
                                    <div>
                                        <label className="view-details-body-label">
                                            ユーザー名
                                            :&nbsp; </label>
                                        {this.state.userInfo.userName}
                                    </div>
                                    <div>
                                        <label className="view-details-body-label">
                                            <FormattedMessage id="app.user-profile.user-profile-info.name"
                                                              defaultMessage="Name"
                                                              description=""/>:&nbsp; </label>
                                        {this.state.userInfo.firstName==null ?
                                            <text></text>:this.state.userInfo.firstName + "  "
                                        }
                                        {this.state.userInfo.lastName==null ?
                                            <text></text>:this.state.userInfo.lastName
                                        }
                                        {/*{this.state.userInfo.firstName + "  " + this.state.userInfo.lastName}*/}
                                    </div>
                                    <div>
                                        <label className="view-details-body-label">
                                            <FormattedMessage id="app.user-profile.user-profile-info.email"
                                                              defaultMessage="Email"
                                                              description=""/>:&nbsp; </label>
                                        {this.state.userInfo.email}</div>
                                    <div>
                                        <label className="view-details-body-label">
                                            <FormattedMessage id="app.user-profile.user-profile-info.phone"
                                                              defaultMessage="Phone"
                                                              description=""/>:&nbsp; </label>
                                        {this.state.contactNumber}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className=" view-details-header-div">
                                <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.order.single.billing.address"
                                                  defaultMessage="Billing Address "
                                                  description=""/>
                            </label>
                                </div>
                                <div className="details-section">
                                    <div>{this.state.billOrderInfo.lastName}&nbsp; {this.state.billOrderInfo.firstName}</div>
                                    <div>{this.state.billOrderInfo.postalCode}</div>
                                    <div>{this.state.billOrderInfo.province}&nbsp;{this.state.billOrderInfo.city}</div>
                                    <div>{this.state.billOrderInfo.streetAddress}</div>
                                    <div>{this.state.billOrderInfo.addressLine2}</div>
                                    {/*<div>{this.state.billOrderInfo.country === "jp" ? "日本" : this.state.billOrderInfo.country}</div>*/}
                                    <div>{this.state.billOrderInfo.cellOrMobileNumber}</div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className=" view-details-header-div">
                                <label className="admin-view-single-order-label">
                                    <FormattedMessage id="app.admin.order.single.shipping.address"
                                                      defaultMessage="Shipping Address "
                                                      description=""/></label>
                                </div>
                                <div className="details-section">
                                    <div>{this.state.shipOrderInfo.lastName}&nbsp;{this.state.shipOrderInfo.firstName} </div>
                                    <div>{this.state.shipOrderInfo.postalCode}</div>
                                    <div>{this.state.shipOrderInfo.province}&nbsp;{this.state.shipOrderInfo.city}</div>
                                    <div>{this.state.shipOrderInfo.streetAddress}</div>
                                    <div>{this.state.shipOrderInfo.addressLine2} </div>
                                    {/*<div>{this.state.shipOrderInfo.country === "jp" ? "日本" : this.state.shipOrderInfo.country}</div>*/}
                                    <div>{this.state.shipOrderInfo.cellOrMobileNumber}</div>
                                </div>
                            </div>
                        </div>
                        <br/>

                    </div>
                    <hr/>
                    <div className="row">
                        <div className="col-md-6 order-summary-details-responsive">
                            <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.single.order.date"
                                                  defaultMessage="Order Date "
                                                  description=""/>&nbsp;:&nbsp;
                            </label>

                            <span>
                                {/*{this.state.createdOn}*/}
                                {/*Postal code*/}
                                {/*Prefecture */}
                                {/*City*/}
                                {/*District*/}
                                {/*village */}
                                {/*Street number*/}
                                {/*Apartment name*/}
                                {/*room number*/}

                                {/*{this.state.createdOn.substring(0, 4)} 年 {this.state.createdOn.substring(5, 7)} 月 {this.state.createdOn.substring(8, 10)} 日*/}
                                {this.state.createdOn}

                                {/*{this.state.orderData.createdOn.substring(0,4)} 年 {this.state.orderData.createdOn.substring(5,7)} 月 {this.state.orderData.createdOn.substring(8,10)} 日*/}
                            </span>
                            <br/>
                            {/*{this.state.orderItems.map(orderItems => {*/}
                                {/*let orderTotalJson = JSON.parse(orderItems.chargeDetails.priceInfoJson);*/}
                                {/*let deliveryDate = orderTotalJson.deliveryDate;*/}
                                {/*if (deliveryDate > initDeliveryDate) {*/}
                                    {/*initDeliveryDate = deliveryDate;*/}
                                {/*}*/}

                            {/*})}*/}
                            <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.single.order.delivery.date"
                                                  defaultMessage="Delivery Date "
                                                  description=""/>&nbsp;:&nbsp;
                            </label>
                            <span>
                                {/*{this.state.deliveryDate.substring(0, 4)} 年 {this.state.deliveryDate.substring(5, 7)} 月 {this.state.deliveryDate.substring(8, 10)} 日*/}
                                {shippedStringDate && shippedStringDate!==null?
                                    shippedStringDate.substring(0, 4)+ "年" +
                                    shippedStringDate.substring(5, 7)+ "月"+
                                    shippedStringDate.substring(8, 10)+ "日"
                                    :"生産中"}
                            </span>
                            <br/>
                            <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.single.order.payment-date"
                                                  defaultMessage="Payment Date "
                                                  description=""/>&nbsp;:&nbsp;
                            </label>
                            <span>
                                {this.state.paymentDate.substring(0, 4)}年{this.state.paymentDate.substring(5, 7)}月{this.state.paymentDate.substring(8, 10)}日

                            </span>
                            <br/>
                            <label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.single.ref-id"
                                                  defaultMessage="Reference Id "
                                                  description=""/>&nbsp;:&nbsp;
                            </label>
                            <span> {this.state.refId}</span>
                            <br/>
                            <label className="admin-view-single-order-label">
                                支払方法&nbsp;:&nbsp;
                            </label>
                            <span> {this.state.paymentMethod}</span>
                            <br/>
                            {this.state.refunded ?
                                <button className="btn btn-danger btn-xs" disabled={true}>
                                    <label className="admin-view-single-order-label">
                                        払い戻し日: &nbsp;
                                    </label>
                                    <span>
                                        {this.state.refundedDate.substring(0, 4)}年 {this.state.refundedDate.substring(5, 7)}月&nbsp;
                                        {this.state.refundedDate.substring(8, 10)}日
                                    </span>
                                    <br/>
                                </button> : ""
                            }

                        </div>
                        <div className="col-md-3 empty-div"></div>
                        {/*{this.state.orderItems.map(orderItems => {*/}
                            {/*let orderTotalJson = JSON.parse(orderItems.chargeDetails.priceInfoJson);*/}
                            {/*let total = orderTotalJson.total;*/}
                            {/*orderTotalFromChargeDetails = orderTotalFromChargeDetails + total;*/}


                        {/*})}*/}
                        <div className="col-md-3 pull-right order-total-div">
                            <div className="admin-single-order-total">
                                <FormattedMessage id="app.admin.single.order.bill.total"
                                                  defaultMessage="Bill Total"
                                                  description=""/>: &nbsp;
                                <span>
                                    ¥ <NumberFormatter num={this.state.orderTotal}/>
                            </span>
                            </div>
                        </div>
                    </div>
                    <br/>

                    <div className="row">
                        <div className="col-md-12 admin-tables">
                            {/*<label className="admin-view-single-order-label">
                                <FormattedMessage id="app.admin.view.single.order.items"
                                                  defaultMessage="Items"
                                                  description=""/>
                            </label>*/}
                            <hr/>

                            <div className="admin-table-row-content">
                                <CustomerOrderItemTable orderItems={this.state.orderItems}
                                                        orderId={this.state.orderId}/>
                            </div>

                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="pull-right">
                            <Link to={"/admin/sales/view"} className="">
                                <FormattedMessage id="app.admin-info.back"
                                                  defaultMessage="<< Back"
                                                  description=""/>
                            </Link>
                        </div>

                    </div>
                </div>

            </div>
        )
    }

}

export default ViewSingleCustomerSales;



// WEBPACK FOOTER //
// ./src/components/Admin/Sales/ViewSingleCustomerSale/ViewSingleCustomerSales.js